import { UserStore } from '@/store/user/user-store';
import { User } from '@/lib/client-auth';

export const userProfileSelectors = {
  email: (s: UserStore): string => s.user?.email || '',
  nickName: (s: UserStore) => {
    return s.user?.name || s.user?.email?.split('@')[0];
  },
  username: (s: UserStore) => {
    return s.user?.email?.split('@')[0] || s.user?.id;
  },
  userAvatar: (s: UserStore): string => s.user?.avatar || '',
  userId: (s: UserStore) => s.user?.id,
  userProfile: (s: UserStore): User | null | undefined => s.user,
};

export const authSelectors = {
  isLoaded: (s: UserStore) => s.isLoaded,
  isLogin: (s: UserStore) => s.isSignedIn,
};

